module.exports = __webpack_public_path__ + "img/mine.e64cfa24.svg";